
// import * as firebase from 'firebase/app';
// import * as firebase from 'firebase/app';
import firebase from 'firebase/app' //after firebase sdk 8.0
import "firebase/auth";
import "firebase/storage";




// initialize firebase
const config = {
    apiKey: "AIzaSyDBHs9oKZrySJDcQYQg648JIr-z5Y3Bmdc",
    authDomain: "sirencare-db.firebaseapp.com",
    databaseURL: "https://sirencare-db-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "sirencare-db",
    storageBucket: "sirencare-db.appspot.com",
    messagingSenderId: "204020629932",
    appId: "1:204020629932:web:29ccf203e6b342eedffa09",
    measurementId: "G-NZV92JQ3EN"
  };


// firebase.database.enableLogging(true);
firebase.initializeApp(config)



firebase.auth().signInWithEmailAndPassword("bighavedev@gmail.com", "!test123")
  .then((userCredential) => {
    // Signed in
    var user = userCredential.user;
    // console.log("firebase user: ", user);
  })
  .catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;

    alert("firebase auth error: ", error);
  });


export default firebase;

